import _extends from "@babel/runtime/helpers/esm/extends";
import { ComponentSize } from '../../declarations/common.decl';
import { SpacerDirection } from '../Spacer';
export var ButtonSize = _extends({
  X_SMALL: 'xSmall'
}, ComponentSize);
export var ButtonVariant;

(function (ButtonVariant) {
  ButtonVariant["PRIMARY"] = "primary";
  ButtonVariant["DESTRUCTIVE"] = "destructive";
  ButtonVariant["INSTRUCTIVE"] = "instructive";
  ButtonVariant["WARNING"] = "warning";
  ButtonVariant["GHOST"] = "ghost";
  ButtonVariant["DARK_GHOST"] = "darkGhost";
  ButtonVariant["BLACK"] = "black";
  ButtonVariant["WHITE"] = "white";
})(ButtonVariant || (ButtonVariant = {}));

export var ButtonMode;

(function (ButtonMode) {
  ButtonMode["FILL"] = "fill";
  ButtonMode["OUTLINE"] = "outline";
  ButtonMode["LINK"] = "link";
})(ButtonMode || (ButtonMode = {}));

export { SpacerDirection as ButtonDirection };